import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const namespace = 'widgets';
export const keyPrefix = 'attach_face_to_card_button';
export const useAttachFaceToCardButtonTranslation = (): UseTranslationResponse<
  typeof namespace,
  typeof keyPrefix
> => useTranslation(namespace, { keyPrefix });

export const ru = ({
  [keyPrefix]: {
    toast_create_card_error: 'Не удалось создать карточку',
    toast_error: 'Не удалось выполнить поиск по карточкам',
    toast_success: 'Лицо добавлено в карточку',
    button_add: 'Добавить в карточку',
    button_face_to_card: 'Лицо в карточку',
    button_create: 'Создать новую',
    button_cancel: 'Отмена',
    button_another: 'Выбрать другую',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    toast_create_card_error: 'Failed to create card',
    toast_error: 'Unable to search for cards',
    toast_success: 'Face added to card',
    button_add: 'Add to card',
    button_face_to_card: 'Face to card',
    button_create: 'Create new',
    button_cancel: 'Cancel',
    button_another: 'Choose another',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    toast_create_card_error: 'Não foi possível criar o cartão',
    toast_error: 'Não foi possível pesquisar os cartões',
    toast_success: 'Rosto adicionado ao cartão',
    button_add: 'Adicionar ao cartão',
    button_face_to_card: 'Cara para carta',
    button_create: 'Criar novo',
    button_cancel: 'Cancelar',
    button_another: 'Escolher outro',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    toast_create_card_error: 'No se pudo crear la tarjeta',
    toast_error: 'No se pudo buscar tarjetas',
    toast_success: 'Rostro añadido a la tarjeta',
    button_add: 'Añadir a la tarjeta',
    button_face_to_card: 'Cara a carta',
    button_create: 'Crear nueva',
    button_cancel: 'Cancelar',
    button_another: 'Elegir otra',
  },
}) as Record<string, unknown>;
